import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import moment from "moment";

@Pipe({
    name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {
    transform(value: any, format: string = 'dd/MM/yyyy'): string {
        if (!value) return '';
        return moment(value).format(format);
    }
}
